import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
// tslint:disable-next-line:quotemark
import { Router, ActivatedRoute, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthService } from './auth.service';
import { VerifyService } from '../global/verify.service';

import { Login, PassResc } from './login-object.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-web',
  templateUrl: './web.component.html',
  styleUrls: ['./web.component.css'],
  providers: [AuthService]
})

export class WebComponent implements OnInit {
  isLogin = true;
  isMail = false;
  isCode = false;
  isPassword = false;
  isChangePassword = false;
  isNotify = false;
  buttonVisible = true;
  version: string = '';
  ambiente = '';
  passLogin;
  tokenPrev;
  responseLogin = {
    Resultado: Number,
    UserToken: String,
    Descripcion: String,
    //Id_User: Number
    Id_Languaje: Number,
    Code_Languaje: String,
    notificationsAccepted: Boolean
  };
  
  log = new Login;
  passResc = new PassResc;
  passNew = {
    'new': '',
    'repeat': ''
  };

  urlLogin: string = '';

  public Preferences_Notification_List: any = [];


  constructor(
    public authService: AuthService,
    private router: Router,
    private toastr: ToastsManager,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private verifyService: VerifyService,
    vcr: ViewContainerRef) {

    this.toastr.setRootViewContainerRef(vcr);

    switch (environment.Ambiente) {
      case 1:
        this.ambiente = 'Prod'
        break;
      case 2:
        this.ambiente = 'Test'
        break;
      default:
        this.ambiente = 'Dev'
        break;
    }

    this.version = "Versión: " + environment.appVersion + '_' + this.ambiente;

    this.urlLogin =  environment.LoginURL + "login/" +
                     environment.Ambiente.toString() + "/" +
                     environment.AppToken;  

  }
  // constructor(public authService: AuthService, private router: Router) {}

  onSubmit(f: NgForm) {
    // onSubmit(f: NgForm, route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.login();
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['id'] != null) {
        // this.tokenTransService(params['id']);
        this.responseLogin.UserToken = params['id'];

        localStorage.setItem('key', String(this.responseLogin.UserToken));

        // this.verifyPermitSessionService();
        const redirect = '/starter';
        this.router.navigate([redirect]);
        this.authService.notifSysGen().subscribe(response => {});


      }

      if (params['languaje'] != null) {
        localStorage.setItem('languaje', String(params['languaje']));
      } else {
        localStorage.setItem('languaje', 'es');
      }
   });
  }

  logout() {
    this.authService.logout();
  }

  navTo(id) {
    const tiempo = 1000;
    // $('html, body').animate({ scrollTop: $(id).offset().top }, tiempo);
    // window.scrollTo(id);
    id.scrollIntoView({behavior: 'smooth'}, tiempo);
    // return false;
  }

  resetViews() {
    this.isLogin = false;
    this.isMail = false;
    this.isCode = false;
    this.isPassword = false;
    this.isChangePassword = false;
    this.isNotify = false;
    this.log = new Login;
  }

  recoverPass() {
    this.resetViews();
    this.isMail = true;
    this.buttonVisible = true;
  }

  loginSesion() {
    this.resetViews();
    this.isLogin = true;
  }

  clickLogin() {
    this.resetViews();
    this.isMail = true;
  }

  clickNewReset() {
    if (this.passNew.new !== '' || this.passNew.repeat !== '' && this.passNew.new === this.passNew.repeat) {
      localStorage.setItem('key', String(this.tokenPrev));

      this.PasswordFirstResetNewByTokenService(this.passNew.new, this.passNew.repeat);
    } else {
      this.toastr.warning('Ingresa ambas contraseñas.', 'Alerta!', { toastLife: 10000, showCloseButton: true });
    }
  }

  clickMail() {
    if (this.passResc.email) {
      this.buttonVisible = false;
      this.resetPasswordService(this.passResc.email);
    } else {
      this.toastr.warning('Favor de escribir un correo.', 'Alerta!', { toastLife: 10000, showCloseButton: true });

    }
  }

  clickCode() {
    if (this.passResc.code) {
      this.confirmResetPasswordService(this.passResc.code);
    } else {
      this.toastr.warning('Favor de escribir el codigo enviado a tu correo.', 'Alerta!', { toastLife: 10000, showCloseButton: true });
    }
  }

  clickPassword() {
    // tslint:disable-next-line:max-line-length
    if (this.passResc.code && this.passResc.password && this.passResc.passwordConfirm && this.passResc.passwordConfirm === this.passResc.password) {
      this.restPasswordNewService(this.passResc.code, this.passResc.password, this.passResc.passwordConfirm);
    } else {
      this.toastr.warning('Las contraseñas son diferentes.', 'Alerta!', { toastLife: 10000, showCloseButton: true });
    }
  }

  login() {

    this.authService.login(this.log).subscribe(res => {
      this.responseLogin = res;
      this.Get_Preferences_Notification_List_By_TokenService(this.responseLogin.UserToken);
      if (res.Resultado === 1) {
        localStorage.setItem('key', String(this.responseLogin.UserToken));
        if (!this.responseLogin.notificationsAccepted) {
          this.resetViews();
          this.isNotify = true;
        } else {
          // this.verifyPermitSessionService();
          const redirect = '/starter';
          this.router.navigate([redirect]);
          this.authService.notifSysGen().subscribe(response => {});
        }
        
      }
      else if (res.Resultado === -1 || res.Resultado === -2) {
        this.toastr.error('Correo o contraseña invalidos.', 'Error', { toastLife: 10000, showCloseButton: true });
      }
      else if (res.Resultado === 2) {
        this.resetViews();
        this.isChangePassword = true;
        this.tokenPrev = this.responseLogin.UserToken;
      }
      else if (res.Resultado === 3) {
        localStorage.setItem('key', String(this.responseLogin.UserToken));
        swal({
          title: 'Terminos y condiciones.',
          // tslint:disable-next-line:max-line-length
          html: 'Los Terminos y Condiciones de uso de Mi Portal han cambiado, lea <a target="_blank" href="/#/terms">aquí</a> el detalle y por favor si esta de acuerdo, acepte los mismos para poder ingresar al sistema.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: 'Acepto',
          cancelButtonText: 'No acepto',
        }).then((result) => {
          if (result.value) {
            this.aceptTermsService();
          }
        });
      }
      else {
        localStorage.setItem('key', '');
        this.toastr.warning(res.Message, 'Error!', { toastLife: 10000, showCloseButton: true });
      }
    });

  }

  enterSystem() {
    this.Save_Preferences_NotificationService();
    const redirect = '/starter';
    this.router.navigate([redirect]);
    this.authService.notifSysGen().subscribe(response => {});
  }

  changeNotif(Id_Preferences_Notification, e) {
    let val = '';
    if (e) {
      val = 'V';
    } else {
      val = 'F';
    }
    this.Update_Preferences_Notification(Id_Preferences_Notification, val);
  }

  resetPasswordService(Email) {
    this.authService.resetPassword(Email).subscribe(res => {
      if (!res.Result) {
        this.toastr.error('El correo electronico no existe.', 'Error', { toastLife: 10000, showCloseButton: true });
      } else {
        this.resetViews();
        this.isCode = true;
        this.toastr.success('Se ha enviado correctamente el correo electronico.', 'Enviado', { toastLife: 10000, showCloseButton: true });
      }

    });
  }

  confirmResetPasswordService(Code) {
    this.authService.confirmResetPassword(Code).subscribe(res => {
      if (!res.Result) {
        this.toastr.error('El código ha expirado o es incorrecto.', 'Error', { toastLife: 10000, showCloseButton: true });
      } else {
        this.resetViews();
        this.isPassword = true;
        this.toastr.success('El código es valido.', 'Valido', { toastLife: 10000, showCloseButton: true });
      }
    });
  }

  restPasswordNewService(Code, Password, PasswordConfirm) {
    this.authService.restPasswordNew(Code, Password, PasswordConfirm).subscribe(res => {
      if (!res.Result) {
        this.toastr.error('Hubo un problema al actualizar contraseña.' + res.Message, 'Error', { toastLife: 10000, showCloseButton: true });
      } else {
        this.resetViews();
        this.isLogin = true;
        this.toastr.success('La contraseña ha sido actualizada.', 'Actualizado', { toastLife: 10000, showCloseButton: true });
      }
      // this.resetViews();
      // this.isLogin = true;
    });
  }
  aceptTermsService() {
    this.authService.aceptTerms().subscribe(resp => {
      if (this.sessionExpired(resp)) {
        if (!this.responseLogin.notificationsAccepted) {
          this.resetViews();
          this.isNotify = true;
        } else {
          // this.verifyPermitSessionService();
          const redirect = '/starter';
          this.router.navigate([redirect]);
        }
      }
    });
  }

  PasswordFirstResetNewByTokenService(Password, Passrepeat) {
    this.authService.PasswordFirstResetNewByToken(Password, Passrepeat).subscribe(resp => {
      if (this.sessionExpired(resp)) {
        this.toastr.success('La contraseña ha sido actualizada.', 'Actualizado', { toastLife: 10000, showCloseButton: true });
        let response = {
          Resultado: Number,
          UserToken: String,
          Descripcion: String,
          Id_User: Number
        };
        response = resp;
        // localStorage.setItem('key', String(response.UserToken));
        // localStorage.setItem('us', String(response.Id_User));
        // const redirect = '/starter';
        // this.router.navigate([redirect]);
        this.loginSesion();
      }
    });
  }

  sessionExpired(res) {
    if (res.Result) {
      return true;
    } else {
      if (res.Codigo === 0) {
        this.toastr.info('Su sesión ha expirado, sera redireccionado.');
        const redirect = '/web';
        this.router.navigate([redirect]);
      } else if (res.Codigo < 0) {
        this.toastr.error(res.Message, 'Error!', { toastLife: 10000, showCloseButton: true });
        return false;
      } else {
        return true;
      }
    }
  }

  verifyPermitSessionService() {
    this.authService.verifyPermitSession().subscribe(resp => {
      if (this.sessionExpired(resp.Permit)) {
        if (!this.responseLogin.notificationsAccepted) {
          this.resetViews();
          this.isNotify = true;
        } else {
          const redirect = '/starter';
          this.router.navigate([redirect]);
        }
      } else {
        this.toastr.info('Usuario sin permisos a la aplicación.');
        localStorage.setItem('key', String(''));
      }
    });
  }

  Get_Preferences_Notification_List_By_TokenService(token) {
    this.authService.Get_Preferences_Notification_List_By_Token(token).subscribe(resp => {
      if (this.sessionExpired(resp)) {
        
        this.Preferences_Notification_List = [];

        resp.forEach(parameter => {
          parameter.oList.forEach(param => {            
            if (param.Value === 'V') {
              param.Value = true;
            } else {
              param.Value = false;
            }
          });
        });

        this.Preferences_Notification_List = resp;

        console.log(this.Preferences_Notification_List);
      }
    });
  }

  Update_Preferences_Notification(Id_Preferences_Notification, Value) {
    this.authService.Update_Preferences_Notification(Id_Preferences_Notification, Value).subscribe(resp => {
      if (this.sessionExpired(resp)) {
      }
    });
  }

  Save_Preferences_NotificationService() {
    this.authService.Save_Preferences_Notification().subscribe(resp => {
      if (this.sessionExpired(resp)) {
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/web/web.component.ts